import { usePostAuthAutologin } from '@r/api/generated/client.ts';
import { useEffect } from 'react';
import { getRouteApi, notFound, type RouteIds, useRouter } from '@tanstack/react-router';
import { Loader } from '@r/components/loader/loader.tsx';

const AutoLoginCallback = () => {
  const router = useRouter();
  const { token } = getRouteApi(
    '/public-autologin-layout/autologin/$token' as RouteIds<typeof router.routeTree>
  ).useParams() as {
    token: string;
  };

  if (!token) {
    throw notFound();
  }

  const autoLoginMutation = usePostAuthAutologin({
    mutation: {
      onSuccess: (data) => {
        localStorage.setItem('token', data.token);
        localStorage.setItem('refreshToken', data.refreshToken);
        window.location.replace('/');
      }
    }
  });

  useEffect(() => {
    autoLoginMutation.mutate({ data: { token } });
  }, []);

  if (autoLoginMutation.isError) {
    throw notFound();
  }

  return (
    <div className="grow">
      <Loader />
    </div>
  );
};

export default AutoLoginCallback;
